
// 精选图书引入图片
import moduleTitle from '../assets/img/home/pre_reading.png'
import L0 from '../assets/img/home/pre_L0.png'
import L1 from '../assets/img/home/pre_L1.png'
import L2 from '../assets/img/home/pre_L2.png'
import L3 from '../assets/img/home/pre_L3.png'
import L4 from '../assets/img/home/pre_L4.png'
import L5 from '../assets/img/home/pre_L5.png'
import L6 from '../assets/img/home/pre_L6.png'

export default {
    namespaced:true,
    state:{
        Imglist:{
            moduleTitle:moduleTitle,
            list:[
                {id:'1',level:L0,title:'L0'},
                {id:'2',level:L1,title:'L1'},
                {id:'3',level:L2,title:'L2'},
                {id:'4',level:L3,title:'L3'},
                {id:'5',level:L4,title:'L4'},
                {id:'6',level:L5,title:'L5'},
                {id:'7',level:L6,title:'L6'}
        ]
    }
   }
}